import React, { useState, useEffect } from "react"; 
import { Modal } from 'react-responsive-modal';
import { CommonUtilities } from "../../commonUtils";
import contractServices from "./contractServices";
import AssociatedTracks from "../MetaData/Tracks/AssociatedTracks";
import AssociatedSongs from "../MetaData/Songs/AssociatedSong";
import AssociatedReleases from "../MetaData/Release/AssociatedRelease";
import Report from "../../components/Common/report";
import ProjectListing from "../../components/Projects/ProjectListing";
import ClientProfileServices from "../User Profile/Client Profiles/clientProfileServices";
import IndicatorSummary from "../Indicator/IndicatorSummary";
import ContractStatmentSummary from "./ContractStatementSummary";
import ContractIndicatorDetail from "./ContractIndicatorDetail";
import ContractNotes from "./ContractNotes";
import { Filter } from "filter";
import CurrentJobs from "components/User Profile/CurrentJobs";

export default function ContractSummary(contractDetails: any) {


    let [showtab, setShowTab] = useState(1);
    let [Rate, setRate] = useState<any[]>([]);
    let [Contacts, setContracts] = useState([]);
    var [client, setClient] = useState<any>([]);
    let [Documents, setDocuments] = useState([]);
    let [Overview, setOverview] = useState<any>([]);
    let [searchValue, setSearchValue] = useState("");
    let [Recouples, setRecouples] = useState<any[]>([]);
    let [Additional, setAdditional] = useState<any>([]);
    let [selectPeriod, SetSelectedPeriod] = useState("");
    let [periodListing, setPeriodListing] = useState<any>([]);
    let [OverviewContact, setOverviewContact] = useState<any>([]);

    let counter = 0;

    let [expandButton, setExpandButton] = useState({
        rateButton: false,
        recouplesButton: false
    })

    const [sndSearch, setSndSearch] = useState("")
    const searchBtn = (e: any) => { setSndSearch(e); }



    useEffect(() => {
        getOverview();
        getClient();

    }, []);



    const periodCount = (e: any) => {
        contractServices.periodCount({ accountingPeriod: e }).then((res) => {
            periodListing = res;
            setPeriodListing(periodListing)

            selectPeriod = res.filter((e: any) => e.periodCurrent == 1)[0]
            SetSelectedPeriod(selectPeriod)
            console.log()
            //selectPeriod, SetSelectedPeriod
        })
    }
    useEffect(() => {
        setPeriodListing(periodListing)

    }, [periodListing]);

    const currentPage = (e: React.SetStateAction<number>) => {
        setShowTab(e);
        return 1;
    }

    const getClient = () => {
        ClientProfileServices.clientDetails().then((res) => {
            setClient(res[0])
        })
    }

    const getOverview = () => {
        contractServices.overview(contractDetails.contractDetails).then((res) => {
            Overview = res
            setOverview(Overview)
            OverviewContact = res.contact
            setOverviewContact(OverviewContact)

            console.log(res.contac)
            if (res.contact.cycle) {

                console.log(res.contact.cycle)
                if (OverviewContact.cycle == "Monthly") {
                    periodCount(1)
                }

                if (OverviewContact.cycle == "Quarterly") {
                    periodCount(2)
                }


                if (OverviewContact.cycle == "Bi-Annually") {
                    periodCount(3)
                }
            }
        })
    }

    const getDocuments = () => {
        contractServices.contractDocument(contractDetails).then((res) => { setDocuments(res) })
    }

    const getRate = () => {
        contractServices.contractRatesBasis(contractDetails.contractDetails).then((res) => {
            setRate(res)
        })
    }

    const getRecouples = () => {
        contractServices.contractRecoupables(contractDetails.contractDetails).then((res) => {
            setRecouples(res)
        })
    }

    const expand = (e: any) => {
        if (e === "rate") {
            setExpandButton(existingValues => ({ ...existingValues, rateButton: !expandButton.rateButton, recouplesButton: expandButton.recouplesButton }))
            getRate();
        } else if (e === "recoupable") {
            setExpandButton(existingValues => ({ ...existingValues, recouplesButton: !expandButton.recouplesButton, rateButton: expandButton.rateButton }))
            getRecouples();
        }
    }
    const closeModal = (e: any) => {
        contractDetails.onchangeContract();
    }

    let [noteOpen, setnoteOpen] = useState(false)

    const onChangContractNote = (e: any) => {
        noteOpen = false;
        setnoteOpen(noteOpen)
    }

    const changeContractSummary = (e: any) => {


        if (e == 1 && counter < contractDetails.ContractList.length) {
            counter += 1;
            //console.log(contractDetails.ContractList[counter].contractTitle  + " " + counter)
            // console.log(contractDetails.ContractList[counter])

            contractDetails.onchangeContract(contractDetails.ContractList[counter]);
        }

        else if (e == 0 && counter > 0) {
            counter -= 1;
            //console.log(contractDetails.ContractList[counter].contractTitle  + " " + counter)
            //console.log(contractDetails.ContractList[counter])
        }

    }
    const openReports = (extension: any, reportNumber: any, contract: any, period: any, contactCode: any) => {
        if (extension == 'xlsx') {
            var url = '/CrystalReport/ExportToExcel.aspx?template=Crystal' + reportNumber + '.rpt';
        } else if (extension == 'xlsxReports') {
            var url = '/CrystalReport/ExportToExcel.aspx?template=Reports/Crystal' + reportNumber + '.rpt';
        } else if (extension == 'csv') {
            var url = '/CrystalReport/ExportToCSV.aspx?template=Crystal' + reportNumber;
        } else if (extension == 'crystalReport') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/Crystal' + reportNumber + '.rpt&format=PDF';
        } else if (extension == 'reportsOnly') {
            var url = '/CrystalReport/Report' + reportNumber + '.aspx?template=Reports/' + reportNumber + 'Report.rpt&format=PDF';
        } else if (extension == 'publisherCollector') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/' + reportNumber + '%20Publisher%20and%20Collector%20Summary.rpt&format=PDF';
        } else if (extension == 'crystalReportBiannual') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/Crystalbiannual' + reportNumber + '.rpt&format=PDF';
        } else if (extension == '412') {
            var url = '/CrystalReport/CrystalReport402.aspx?template=Reports/Crystal412.rpt&format=PDF';
        } else if (extension == '411') {
            var url = '/CrystalReport/Report401.aspx?template=Reports/Crystal411.rpt&format=PDF';
        } else if (extension == 'pdf') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/Crystal' + reportNumber + '.rpt&format=PDF';
        } else if (extension == 'contractListing') {
            var url = '/CrystalReport/ContractListing.aspx?template=Reports/ContractListingRpt.rpt&format=PDF';
        } else if (extension == 'rpt') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/Crystal' + reportNumber + '.rpt';
        } else if (extension == 'rptPDF') {
            var url = '/CrystalReport/CrystalReport' + reportNumber + '.aspx?template=Reports/Crystal' + reportNumber + '.rpt&format=PDF';
        } else if (extension == 'excel401') {
            var url = '/CrystalReport/ExportToExcel.aspx?template=401Report' + reportNumber;
        } else {
            var url = '/CrystalReport/Report' + reportNumber + '.aspx?template=Reports/Crystal' + reportNumber + '.rpt';
        }

        if (contactCode.length > 0) {
            url = url + '&contactCode=' + encodeURIComponent(contactCode);
        }
        if (period.length > 0) {
            url = url + '&periodNum=' + encodeURIComponent(period);
        }
        if (contract.length > 0) {
            url = url + '&contractRefNum=' + encodeURIComponent(contract);
        }

        window.open(url);
    }

    const excelGenericExport = (fileName: any) => {

        var payload = {
            exportType: "_testing_2025",
            type: fileName,
            contractRefNum: Overview?.contractRefNum,
            periodNum: 20241231
        }
        if (fileName == "By Contract 121") {
            contractServices.excelGeneric(payload)
        }

        if (fileName == "Excel121") {

        }
    }

    let [ContractSettings, setContractSettings] = useState(false);

    let [ContractReportList, setContractReportList] = useState<any>([]);
    let [ReportList, setReportList] = useState<any>([]);
    const contract_setting = () => {
        contractServices.ContractReportingList({ contractRefNum: Overview?.contractRefNum }).then((respond: any) => {
            ContractReportList = respond;
            setContractReportList(ContractReportList)
        })

        contractServices.reportList({ isStatement: true, isReportMenu: true }).then((respond: any) => {
            ReportList = respond;
            setReportList(ReportList)
        })
    }

    return (
        <>
            <Modal open={contractDetails.open} onClose={() => closeModal(true)} styles={{ modalContainer: { background: 'transparent !important', height: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-12 paddingCenterBox pull-right bgTransparent allowHscroll allowVscroll' }} >

                <div className="box ws-12">
                    <div className="box-header-main">
                        <h2 className="ws-4" > Contract Summary</h2>
                        <CurrentJobs type="calculation" />

                        <div className={(contractDetails.from === "project") ? "pull-right hide" : "hide"} >
                            <button type="button" className="icon-btn edit pull-right" onClick={() => changeContractSummary(1)}>
                                Next
                            </button>
                            <div className="pull-right mrl mll mt ">
                                {Overview.contractTitle} {counter}
                            </div>
                            <button type="button" className="icon-btn edit pull-right" onClick={() => changeContractSummary(0)}>
                                Back
                            </button>
                        </div>
                    </div>

                    <div className="ws-12">

                        <div className="w-27 pm">

                            <div className="ws-12 m0 mt">
                                <button className="icon-btn info pull-right" onClick={() => { setContractSettings(!ContractSettings); contract_setting() }}>
                                    <i className="icon-LPurple-Setting m0 p0"></i>
                                </button>

                                <button type="button" className="icon-btn edit pull-right" >
                                    <i className="icon-edit1"></i>
                                </button>

                                <span className="ws-9 text-big text-bold ">{Overview.contractTitle}</span>
                                <span className="ws-9 mts ">({Overview.contractRefNum})</span>

                            </div>

                            <hr className="ws-11 dottedHr mts"></hr>

                            <div className="ws-12">
                                <div className="ws-12 ">
                                    <span className="primary">Contact Title : </span>
                                    <span>{OverviewContact.displayName} ({OverviewContact.kontactCode}) </span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">Cycle : </span>
                                    <span>{OverviewContact.cycle}</span>
                                </div>

                                <div className="ws-5 mt ">
                                    <span className="primary">Due days : </span>
                                    <span>{OverviewContact.dueDays}</span>
                                </div>

                                <div className="pull-right prs">
                                    <button className="icon-btn primary pull-right height30" title="Excel by Contact" ng-click="openReports('xlsx', '102', contractDetails.contact.kontactCode, '', periodSelected, '', '')"
                                        onClick={() => openReports('xlsx', '102', '', '20241231', OverviewContact.kontactCode)}>
                                        <i className="icon-file-excel-o  "></i>
                                    </button>

                                    <button className="icon-btn primary pull-right height30" title="By Contract 122" ng-click="excelGenericExport('By Contract 121')" onClick={() => excelGenericExport('By Contract 121')}>
                                        <i className="icon-file-excel-o "></i>
                                    </button>

                                    <button className="icon-btn primary pull-right height30" title="Excel 121" ng-click="excelGenericExport('Excel121')" onClick={() => excelGenericExport('Excel121')}>
                                        <i className="icon-file-excel-o "></i>
                                    </button>

                                    <button className="icon-btn delete pull-right height30" title="By Contract 121" ng-click="openReports('pdf', '121', '', '', periodSelected, '', contractDetails.contractRefNum)"
                                        onClick={() => openReports('pdf', '121', Overview.contractRefNum, '20241231', '')}>
                                        <i className="icon-file-pdf-o "></i>
                                    </button>

                                </div>

                            </div>

                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                            <div className="ws-12">
                                <div className="ws-12 mb">
                                    <span className="primary">Contact Status : </span>
                                    <a className={Overview.contractStatus != null ? "btn-xs pull-right width100 height25 text-center" : "hide"}
                                        style={{
                                            background: CommonUtilities.lookUpTypeList('contractStatusName', Overview.contractStatus, 'bgColor'),
                                            color: CommonUtilities.lookUpTypeList('contractStatusName', Overview.contractStatus, 'fontColor')
                                        }} >{Overview.contractStatus}</a>
                                </div>

                                <div className="ws-12 mt mb">
                                    <span className="primary">Account Status : </span>
                                    <a className={OverviewContact.accountStatus != null ? "btn-xs pull-right width100 height25 text-center " : "hide"}
                                        style={{
                                            background: CommonUtilities.lookUpTypeList('accountStatusName', OverviewContact.accountStatus, 'bgColor'),
                                            color: CommonUtilities.lookUpTypeList('accountStatusName', OverviewContact.accountStatus, 'fontColor')
                                        }} >{OverviewContact.accountStatus}</a>
                                </div>

                                <div className="ws-12 mt mb">
                                    <span className="primary">Account Extended Status : </span>
                                    <a className={OverviewContact.accountExtendedStatus != null ? "btn-xs pull-right width100 height25 text-center " : "hide"}
                                        style={{
                                            background: CommonUtilities.lookUpTypeList('accountStatusExtName', OverviewContact.accountExtendedStatus, 'bgColor'),
                                            color: CommonUtilities.lookUpTypeList('accountStatusExtName', OverviewContact.accountExtendedStatus, 'fontColor')
                                        }}>{OverviewContact.accountExtendedStatus}</a>
                                </div>

                                <div className="ws-12 mt mb">
                                    <span className="primary">Statement Status : </span>
                                    <a className={OverviewContact.statementStatus != null ? "btn-xs pull-right width100 height25 text-center " : "hide"}
                                        style={{
                                            background: CommonUtilities.lookUpTypeList('statementStatusName', OverviewContact.statementStatus, 'bgColor'),
                                            color: CommonUtilities.lookUpTypeList('statementStatusName', OverviewContact.statementStatus, 'fontColor')
                                        }}>{OverviewContact.statementStatus}</a>
                                </div>

                                <div className="ws-12 mt mb">
                                    <span className="primary">Payee Status : </span>
                                    <a className={OverviewContact.payeeName != null ? "btn-xs pull-right width100 height25 text-center " : "hide"}
                                        style={{
                                            background: CommonUtilities.lookUpTypeList('payeeName', OverviewContact.payeeName, 'bgColor'),
                                            color: CommonUtilities.lookUpTypeList('payeeName', OverviewContact.payeeName, 'fontColor')
                                        }}>{OverviewContact.statementStatus}</a>
                                </div>

                            </div>

                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                            <div className="ws-12">

                                <div className="ws-12 ">
                                    <span className="primary">Payee Name : </span>
                                    <span>{OverviewContact.payeeName}</span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">Payee #: </span>
                                    <span>{OverviewContact.payee}</span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">In Care Of Name : </span>
                                    <span>{OverviewContact.inCareofName}</span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">Address Info : </span>
                                    <span>{Overview.accountInfo}</span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">Email : </span>
                                    <span>{OverviewContact.emailPayee}</span>
                                </div>
                            </div>

                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                            <div className="ws-12">

                                <div className="ws-12 ">
                                    <span className="primary">Email : </span>
                                    <span>{OverviewContact.kontactEmail}</span>
                                </div>

                                <div className="ws-12 mt ">
                                    <span className="primary">Address : </span>
                                    <span>{OverviewContact.kontactAddress}</span>
                                </div>

                            </div>
                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>
                            <div className="ws-12">

                                <div className="ws-12  " >
                                    <span className="primary">Coogan : </span>
                                    <span>{OverviewContact.coogan} </span>
                                </div>

                                <div className="ws-12 mt  " >
                                    <span className="primary">Limited Rights : </span>
                                    <span>{OverviewContact.limitedRights}  </span>
                                </div>
                            </div>

                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                            {(() => {
                                if (selectPeriod && Overview.contractRefNum) {
                                    return (
                                        <IndicatorSummary paramDetail={{ contract: Overview.contractRefNum, period: selectPeriod, type: "ContractLeft", homeCurrency: client.homeCurrency }} />
                                    )
                                }
                            })()}


                            <hr style={{ "borderTop": "solid 2px #E3E6EC !important" }}></hr>

                            <div className="ws-12 hide">

                                <div className="ws-12  " >
                                    <span className="primary hide">Period Status </span>
                                </div>

                                <div className="hide">
                                    <Report period={Additional} />
                                </div>
                            </div>

                            <hr className="ws-11 mt dottedHr hide" />
                            <div className="ws-12 hide">

                                <div className="ws-12 mt  " >
                                    <span className="primary">Contract Documents </span>
                                </div>

                                {Documents.map(post => (
                                    <span className="icon-btn delete ms " >
                                        <i className="icon-data-analytics"></i>
                                    </span>
                                ))}

                            </div>
                            {(() => {
                                if (selectPeriod && Overview.contractRefNum) {
                                    return (
                                        <ContractStatmentSummary paramDetail={{ contract: Overview.contractRefNum, period: selectPeriod, type: "ContractLeft", homeCurrency: client.homeCurrency }} />
                                    )
                                }
                            })()}
                        </div>

                        <div className="w-73 landing">

                            {ContractSettings && <div className="ws-8 positionRelative">

                                <div className="dockingSlider pLarge ws-7" ng-init="openTab = false;" style={{ height: "100%", top: "0" }} ng-className="openTab ? 'ws-6': 'w-0'">
                                    <div className="ws-12 centerWindow">

                                        <div className="box">
                                            <div className="box-header"> <h2>Contract Settings</h2> </div>
                                            
                                            <div className="box-content">
                                                <div className="alert alert-success" data-ng-show="saveAlert"> Contract settings have been added/updated successfully  </div>

                                                <div className="form-format ws-5">
                                                    <label >Reporting Start Date</label>
                                                    <div className="label-entries">
                                                        <input type="text" ng-model="contractNewReportDetails.reportingStartDate" placeholder="Reporting Start Date" />
                                                    </div>
                                                </div>

                                                <div className="form-format ws-5">
                                                    <label >Reporting End Date</label>
                                                    <div className="label-entries">
                                                        <input type="text" ng-model="contractNewReportDetails.reportingEndDate" placeholder="Reporting End Date" />
                                                    </div>
                                                </div>

                                                <div className="ws-2" style={{ marginTop: "30px !important" }}>
                                                    <button className="icon-btn edit btn-xs" type="button" data-ng-click="selectPeriodRange(0)" title="Select Period">
                                                        <i className="icon-calendar"></i>
                                                    </button>
                                                </div>

                                                <div className="form-format ws-6">
                                                    <label >
                                                        <input type="checkbox" title="noEndDate" ng-true-value="1" ng-false-value="0" ng-model="contractDetails.noEndDate" />
                                                        No End Date
                                                    </label>
                                                </div>

                                                <div className="ws-12">
                                                    <h2 className="ws-12">Send Summary</h2>
                                                    <button className="btn icon-btn delete mt" title="Send Summary"><i className="icon-file-pdf-o"></i></button>

                                                    <ul className="nav nav-tabs">
                                                        <li className="nav-horizontal active hide">Yes </li>
                                                        <li >No</li>
                                                        <li >Custom</li>
                                                        <li className="nav-horizontal">Standard</li>
                                                    </ul>
                                                </div>
                                                <div className="ws-12">
                                                    <h2 className="ws-12">Send Detail</h2>
                                                    <button className="btn icon-btn delete mt" title="Send Detail">
                                                        <i className="icon-file-pdf-o"></i>
                                                    </button>

                                                    <ul className="nav nav-tabs">
                                                        <li className="nav-horizontal active hide"> Yes </li>
                                                        <li >No  </li>
                                                        <li >Custom  </li>
                                                        <li className="nav-horizontal">  Standard  </li>
                                                    </ul>

                                                </div>

                                                <div className="form-format ws-12">
                                                    <label>Statement</label>
                                                    <div className="label-entries">
                                                        <select id="contactInfo.defaultStatement" name="basis">
                                                            <option value="" >Choose Statement</option>
                                                            {
                                                                ReportList?.map((val: any) => {
                                                                    return (
                                                                        <option value="0" label={val?.name + " - " + val?.label}>{val?.name} {val?.label}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="ws-12">
                                                    <h2 className="ws-12">Send Excel</h2>
                                                    <button className="btn icon-btn edit mt" title="Detail"> <i className="icon-file-excel-o"></i></button>

                                                    <ul className="nav nav-tabs">
                                                        <li className="nav-horizontal active hide"> Yes </li>
                                                        <li >No  </li>
                                                        <li >Custom  </li>
                                                        <li className="nav-horizontal">  Standard  </li>
                                                    </ul>
                                                    
                                                </div>
                                            </div>

                                            <div className="box-footer">
                                                <button type="button" className="icon-btn edit" ng-click="contractSettingsUpdate(contractNewReportDetails);"><i className="icon-save"></i>  Save </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="positionAbsolute" style={{ right: "0px", zIndex: "9", top: "0px" }} ng-className="openTab? '' : ''">
                                        <i onClick={() => setContractSettings(!ContractSettings)} className="text-xxl icon-window-close danger "></i>
                                    </div>
                                </div>

                            </div>}

                            <div className="ws-12 pLarge">

                                <div className="input-group">


                                    {(() => {

                                        if (periodListing) {

                                            return (

                                                <select className="pull-left mrl">
                                                    {
                                                        periodListing?.map((value: any) => {
                                                            return (
                                                                <option>{Filter.SimplemonthAndDayYear(value.periodFrom)} - {Filter.SimplemonthAndDayYear(value.periodTo)}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            )
                                        }
                                    })()}

                                    <button className="btn-info m0 height35"> {Overview?.periodStatus} </button>
                                    <div className="pull-right pm mrl text-bold "> {client.homeCurrency}</div>
                                </div>

                                <IndicatorSummary paramDetail={{ contract: Overview.contractRefNum, period: selectPeriod, type: "ContractTop", homeCurrency: client.homeCurrency }} />

                                <ContractIndicatorDetail paramDetail={{ contract: Overview.contractRefNum, period: selectPeriod, type: "ContractTop", homeCurrency: client.homeCurrency }} />


                                <div className="box mt hide">
                                    <div className="box-content">
                                        <a className="btn">Performance</a>
                                        <a className="btn">Royalties</a>
                                        <a className="btn">Project Analysis</a>
                                        <a className="icon-btn edit pull-right">Contract Calculations</a>
                                        <a className="icon-btn edit pull-right">Contract Compare</a>
                                    </div>
                                </div>

                                <div className="ws-12 ptxl ">
                                    <div className="box topFrame">
                                        <div className="box-header m0">
                                            <h2 className="ws-8">Account Notes</h2>
                                            <a className="icon-btn info width70 height30 pull-right" onClick={() => setnoteOpen(true)}>Notes </a>
                                        </div>

                                    </div>
                                </div>

                                <div className="ws-6 ptxl prl">
                                    <div className="box">
                                        <div className="box-header" >
                                            <h2 className="ws-6">Royalty Rates</h2>
                                            <button className="btn-xs icon-btn info pull-right" >
                                                <i className={expandButton.rateButton ? 'icon-minus1' : 'icon-plus1'} onClick={() => expand("rate")}></i>
                                            </button>
                                            <button type="button" className="icon-btn edit pull-right btn-xs hide">
                                                <i className="icon-edit1"></i>
                                            </button>
                                        </div>

                                        {expandButton.rateButton && <div className=" pr pl allowHscroll height200">
                                            {(Rate.length > 0) && <table className='NewTable allowHscroll allowVscroll mt '>
                                                <thead>
                                                    <tr >
                                                        <th className="forceSingleLine">Region</th>
                                                        <th className="forceSingleLine">Format/Source Codes</th>
                                                        <th className="forceSingleLine">Income Rate</th>
                                                        <th className="forceSingleLine">Price Basis</th>
                                                        <th className="forceSingleLine">Price</th>
                                                        <th className="forceSingleLine">Discount </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                </tbody>
                                                {
                                                    Rate.map(post => (
                                                        <tr >
                                                            <td>{post.groupDesc}</td>
                                                            <td>{post.format}</td>
                                                            <td>{post.rate}</td>
                                                            <td>{post.usePrice}</td>
                                                            <td>{post.price}</td>
                                                            <td>{post.discount}</td>
                                                        </tr>

                                                    ))
                                                }
                                                <tbody>
                                                </tbody></table>}
                                            {(Rate.length === 0) && <div className="alert alert-info mt mrl mbl hide"> No data to display</div>}
                                            {(Rate.length == 0) && <div className="height200"> </div>}
                                        </div>}

                                    </div>
                                </div>

                                <div className="ws-6 ptxl">
                                    <div className="box">
                                        <div className="box-header" >
                                            <h2 className="ws-6">Recoupables</h2>
                                            <button className="btn-xs icon-btn info pull-right" >
                                                <i className={expandButton.recouplesButton ? 'icon-minus1' : 'icon-plus1'} onClick={() => expand("recoupable")}>
                                                </i>
                                            </button>
                                            <button type="button" className="icon-btn edit pull-right btn-xs hide">
                                                <i className="icon-edit1"></i>
                                            </button>
                                        </div>

                                        {expandButton.recouplesButton && <div className="pr pl allowHscroll height2000">
                                            {(Recouples.length > 0) && <table className={expandButton.recouplesButton ? 'NewTable allowHscroll allowVscroll mt' : 'hide'}>
                                                <thead>
                                                    <tr>
                                                        <th className="forceSingleLine">Region</th>
                                                        <th> className="forceSingleLine"Format/Source Codes</th>
                                                        <th className="forceSingleLine">Cost Rate</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                </tbody>
                                                {
                                                    Recouples.map(post => (
                                                        <tr>
                                                            <td>{post.groupDesc}</td>
                                                            <td>{post.format}</td>
                                                            <td>{post.costRate}</td>
                                                        </tr>
                                                    ))
                                                }
                                                <tbody>
                                                </tbody></table>}
                                            {(Recouples.length == 0) && <div className="alert alert-info mt mrl mbl hide"> No data to display</div>}
                                            {(Recouples.length == 0) && <div className="height200"> </div>}
                                        </div>}


                                    </div>
                                </div>

                                <div className="ws-12 hide">
                                    <div className="pLarge">
                                        <a className="btn">Performance</a>
                                        <a className="btn" >Financial</a>
                                        <a className="btn" >Reserves</a>
                                        <a className="btn" >Adjustments</a>

                                        <a className="icon-btn edit pull-right btn-sm" >
                                            <i className="icon-sigma-sum"></i>
                                        </a>

                                        <a className="pull-right icon-btn primary mb btn-sm" >
                                            <i className="icon-book"></i>
                                        </a>

                                        <a className="pull-right icon-btn primary mb btn-sm" >
                                            <i className="icon-files"></i>
                                        </a>

                                        <a className="pull-right btn-queue mb btn-sm" >
                                            <i className="icon-save"></i>
                                        </a>

                                        <a className="icon-btn primary pull-right btn-sm">
                                            <i className="icon-generate-report"></i>
                                        </a>

                                    </div>
                                </div>

                                <div className="box mt">
                                    <div className="box-header">
                                        Scope
                                    </div>
                                    <div className="box-content">
                                        <div className="ws-12">
                                            <ul className="nav nav-tabs m0 p0">
                                                <li className={showtab === 1 ? "btn active" : " "} onClick={() => currentPage(1)}>Tracks</li>
                                                <li className={showtab === 2 ? "btn active" : " "} onClick={() => currentPage(2)}>Songs</li>
                                                <li className={showtab === 3 ? "btn active" : " "} onClick={() => currentPage(3)}>Release</li>
                                                <li className={showtab === 4 ? "btn active" : " "} onClick={() => currentPage(4)}>Projects</li>
                                            </ul>

                                            <div className="form-format pull-right ws-6 m0 p0" >
                                                <label className="control-label ws-4 text-right ps pt "></label>

                                                <div className={showtab === 0 ? "label-entries ws-7" : "label-entries ws-7 hide"}>
                                                    <div className="ws-10">
                                                        <input type="text" className="form-control" placeholder="Search Text"
                                                            value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }}
                                                        />
                                                    </div>
                                                    <div className="ws-2">
                                                        <button className="icon-btn edit" >
                                                            <i className="icon-search" onClick={() => searchBtn(searchValue)}></i>
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="ws-12">

                                            {(() => {
                                                switch (showtab) {
                                                    case 1: return <AssociatedTracks contractDetails={contractDetails.contractDetails} />;
                                                    case 2: return <AssociatedSongs contractDetails={contractDetails.contractDetails} />;
                                                    case 3: return <AssociatedReleases contractDetails={contractDetails.contractDetails} />;
                                                    case 4: return <ProjectListing contractDetails={contractDetails.contractDetails} />;
                                                    default: return <AssociatedTracks contractDetails={contractDetails.contractDetails} />;
                                                }
                                            })()}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {(() => {

                        if (noteOpen) {
                            return <ContractNotes noteOpen={noteOpen} onChangContractNote={onChangContractNote} selectedMainWizard={contractDetails.contractDetails} />
                        }

                    })()}

                </div>

            </Modal >
        </>
    )
}